/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Level_3Inputs */

const en_statement_taxonomy_editor_level_3 = /** @type {(inputs: Statement_Taxonomy_Editor_Level_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level 3`)
};

const nl_statement_taxonomy_editor_level_3 = /** @type {(inputs: Statement_Taxonomy_Editor_Level_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau 3`)
};

/**
* | output |
* | --- |
* | "Level 3" |
*
* @param {Statement_Taxonomy_Editor_Level_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_level_3 = /** @type {((inputs?: Statement_Taxonomy_Editor_Level_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Level_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_level_3(inputs)
	return en_statement_taxonomy_editor_level_3(inputs)
});